import React, { ReactNode } from "react"
import "../assets/fonts/index.css"
import Footer from "./footer"
import { css } from "@emotion/react"
import { Header } from "./header/Header"
import "./global.css"
import { useLogNetworkLoss } from "../hooks/use-log-network-loss"

type Props = {
  hideAuth?: boolean
  countryCode?: string
  showCheckoutButton?: boolean
  cartLength?: number
  children: ReactNode
  setCartVisible?: React.Dispatch<React.SetStateAction<boolean>>
}

export const Layout = ({ children, ...restProps }: Props) => {
  useLogNetworkLoss()

  const containerStyles = css`
    max-width: 100%;
    flex-direction: column;
    min-height: 100vh;
    display: flex;
  `

  return (
    <div css={containerStyles}>
      <Header {...restProps} />
      {children}
      <Footer />
    </div>
  )
}
